var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageType === _vm.pageConfig.personal.type)?_c('PersonalDetail'):_vm._e(),_vm._v(" "),(_vm.pageType === _vm.pageConfig.enterprise.type)?_c('EnterpriseDetail'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }